import './App.css';

import { BackTop, Layout } from 'antd';
import * as React from 'react';

import { SiteHeader } from './components/SiteHeader';
import { Routes } from './Routes';

const { Content } = Layout;
const images: string[] = [
  'images/button_grouphover.png',
  'images/button_hover.png',
  'images/button_pressed.png',
  'images/button_rest.png',
  'images/flip_grouphover.png',
  'images/flip_hover.png',
  'images/flip_pressed.png',
  'images/flip_rest.png',
  'images/fullpage_grouphover.png',
  'images/fullpage_hover.png',
  'images/fullpage_pressed.png',
  'images/fullpage_rest.png',
  'images/home_grouphover.png',
  'images/home_hover.png',
  'images/home_pressed.png',
  'images/home_rest.png',
  'images/map-thumbnail.jpg',
  'images/next_grouphover.png',
  'images/next_hover.png',
  'images/next_pressed.png',
  'images/next_rest.png',
  'images/previous_grouphover.png',
  'images/previous_hover.png',
  'images/previous_pressed.png',
  'images/previous_rest.png',
  'images/printer.png',
  'images/rotateleft_grouphover.png',
  'images/rotateleft_hover.png',
  'images/rotateleft_pressed.png',
  'images/rotateleft_rest.png',
  'images/rotateright_grouphover.png',
  'images/rotateright_hover.png',
  'images/rotateright_pressed.png',
  'images/rotateright_rest.png',
  'images/zoomin_grouphover.png',
  'images/zoomin_hover.png',
  'images/zoomin_pressed.png',
  'images/zoomin_rest.png',
  'images/zoomout_grouphover.png',
  'images/zoomout_hover.png',
  'images/zoomout_pressed.png',
  'images/zoomout_rest.png',
  'screenshots/checkbox-checked.png',
  'screenshots/checkbox-unchecked.png',
  'screenshots/down-arrow.png',
  'screenshots/help-icon.png',
  'screenshots/jump-to-image-btn.png',
  'screenshots/lrs-logo.png',
  'screenshots/print-navigation.png',
  'screenshots/result-icon-with-count.png',
  'screenshots/results-pagination.png',
  'screenshots/right-arrow.png',
  'screenshots/search-btn.png',
  'screenshots/search-icon.png',
  'screenshots/search-results.png',
  'screenshots/show-image-metadata-btn.png',
];
class App extends React.Component<any, any>  {

  constructor(props: any) {
    super(props);
    this.updateShowMessage = this.updateShowMessage.bind(this);
    this.state = {
      showMessage: 'valid'
    };
  }

  componentWillMount() {
    images.forEach((image) => {
      new Image().src = image
    });
  }
  public render() {
    return (
      <div className="App">
        <Layout>
          <SiteHeader showMessage={this.state.showMessage}/>
          <Content id="main-wrapper" >
            <Routes updateShowMessage={this.updateShowMessage} />
          </Content>
          <BackTop />
        </Layout>
      </div>
    );
  }

  updateShowMessage(messageType: string) {
    this.setState({
      showMessage: messageType
    });
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx